import styled, { css } from 'styled-components'
import { device, fonts } from '../../../styles/GlobalVariables'

interface VerticalPlayerItemDivProps {
  poster?: string
  isMiniSeries?: boolean
}

export const Container = styled.div<VerticalPlayerItemDivProps>`
  position: relative;
  aspect-ratio: 9/16;
  background-image: ${props =>
    props.poster ? `url(${props.poster})` : 'none'};
  background-size: cover;
  background-position: center center;
  ${props =>
    props.isMiniSeries &&
    css`
      border-radius: 4px;
      overflow: hidden;
    `}

  .KalturaThumbnailEmbed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

export const StyledVideo = styled.video<{ display: 'block' | 'none' }>`
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  display: ${props => props.display};
`
export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  will-change: transform;
  padding: 4px 10px;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 6px;

  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 59.99%,
    #000 103.03%
  );

  ${device.medium} {
    background-image: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 65.98%,
      rgba(0, 0, 0, 0.9) 100%
    );
  }

  ${device.small} {
    .PlayWithCircle {
      display: none;
    }
  }

  .PlayWithCircle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`
export const TitleOverlay = styled.span<{ isMiniSeries: boolean }>`
  font-family: ${fonts.narkis};
  color: white;
  font-size: 18px;
  font-weight: 700;
  line-height: 120%;
  text-align: right;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  text-shadow: 0 9px 9px rgba(0, 0, 0, 0.4);
  display: -webkit-box;
  -webkit-line-clamp: ${props => (props.isMiniSeries ? 2 : 3)};
  -webkit-box-orient: vertical;
  overflow: hidden;
  ${props =>
    props.isMiniSeries &&
    css`
      min-height: 43px;
    `}
`
